<template>
	<div class="mygoods">
		<div >
		<Qrcode-Dialog :showSales.sync="showSales" :salesItem="salesItem"/>
		<el-dialog :title="$t('other.a1942')" :visible.sync="syncOrders" width="30%">
			<div>
				<el-select
				    v-model="value10"
				    multiple
				    filterable
				    allow-create
				    default-first-option
				    :placeholder="$t('other.a1359')">
				    <el-option
				      v-for="item in options5"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="syncOrders = false">{{$t('other.a106')}}</el-button>
				<el-button type="primary" @click="comfirm()">{{$t('other.a279')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog
		  :title="text"
		  :visible.sync="showStore"
		  width="50%"
		  >
		 <div style="width: 100%;margin: 20px 0;">
			 <div style="font-size: 18px;padding: 10px;">
				 <span>{{$t('other.a1674')}}：{{showShopName(selectedOptions2)}}</span>
				 <span v-show="whichMethods == 2 || whichMethods == 3"> -- {{$t('other.a1943')}}：{{chooseParams.length == 1 ? $t('other.a1945') :chooseParams[chooseParams.length-1]}}</span>
				 <span v-show="whichMethods == 4 || whichMethods == 5"> -- {{$t('other.a1944')}}：{{targetList.length}}</span>
			 </div>
			 <el-select v-model="chosedStore"  :placeholder="$t('mygoods').qingdang.choose" >
			 	<el-option v-for="store in storeList" :key="store.value" :label="store.label" :value="store">
			 	</el-option>
			 </el-select>
		 </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="showStore = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="massGenerage()">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<el-dialog :title="$t('other.a142')" :visible.sync="dialogVisible" width="30%">
			<span>{{visiableMessage}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">{{$t('other.a884')}}</el-button>
			</span>
		</el-dialog>
		<!-- 商品清单 -->
		<el-dialog :title="$t('mygoods').qingdang.title" :visible.sync="caigouTable"  width="70%">
			<div >
				<el-table :data="isChooseList" height="500" border>
					<el-table-column property="name" label="Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" label="" trigger="hover">
								<img  :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img   slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="name" label="VaritionName" width="280" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.variation.name" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column property="variation.name" label="VaritionSku"  :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.variation.variationSku" ></el-input>
						</template>
					</el-table-column>
					<el-table-column label="Cost" >
						<template scope="scope">
							<el-input size="mini"  type="number"  v-model="scope.row.cost" clearable></el-input>
						</template>
					</el-table-column>
						<el-table-column label="Type" >
						<template scope="scope">
							<el-select v-model="scope.row.component" :disabled="disabled" :placeholder="$t('other.a50')">
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value">
									</el-option>
							</el-select>
								
						</template>
					</el-table-column>
					<el-table-column :label="$t('mygoods').qingdang.operate" >
						<template scope="scope">
							<el-button type="text" size="mini" @click="deleteChoose(scope.row)" style="width: 60px;">{{$t('mygoods').qingdang.dele}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="choos-store">
					<div class="select-store">
						<span>{{$t('mygoods').qingdang.store}}：</span>
						<el-select v-model="chosedStore" @change="vertifyStoreType()" size="small" :placeholder="$t('mygoods').qingdang.choose" >
							<el-option v-for="store in storeList" :key="store.value" :label="store.label" :value="store">
							</el-option>
						</el-select>
					</div>
				
					<div >
						<el-button  @click="cleanForm">{{$t('mygoods').qingdang.qingkong}}</el-button>
						<el-button  @click="createOrder" type="primary">{{$t('mygoods').qingdang.submit}}</el-button>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="$t('mygoods').details.title" :visible.sync="storetable" center width="80%">
			<div class="quit-wapper">
				<span class="quit-wrapper-item">{{$t('mygoods').details.success}}</span>
				<span class="quit-wrapper-item">{{$t('mygoods').details.fail}}</span>
			</div>
			<div class="quit-box" >
				<el-table style="margin-left: 10px;" :data="succesList"  height="460px" border>
					<el-table-column property="name" :label="$t('mygoods').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<!-- <el-input size="mini" v-model="scope.row.image" clearable></el-input> -->
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="itemName" :label="$t('mygoods').details.name" width="190" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.itemName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="skuName" :label="$t('mygoods').details.SKU" width="150" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.skuName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('mygoods').details.cusCode" width="136" :show-overflow-tooltip="true">
					<!-- 	<template scope="scope">
							<el-input size="mini" v-model="scope.row.cusCode" clearable></el-input>
						</template> -->
					</el-table-column>
					
				</el-table>
				<el-table style="margin-left: 10px;" :data="errorList" height="460px" border>
					<el-table-column property="name" :label="$t('mygoods').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<!-- <el-input size="mini" v-model="scope.row.image" clearable></el-input> -->
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="itemName" :label="$t('mygoods').details.name" width="190" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.itemName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="skuName" :label="$t('mygoods').details.SKU" width="150" :show-overflow-tooltip="true">
					<!-- 	<template scope="scope">
							<el-input size="mini" v-model="scope.row.skuName" clearable></el-input>
						</template> -->
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('mygoods').details.cusCode" width="136" :show-overflow-tooltip="true">
						<!-- <template scope="scope">
							<el-input size="mini" v-model="scope.row.cusCode" clearable></el-input>
						</template> -->
					</el-table-column>
					
					
				</el-table>

			</div>
			
			<div class="ttp-uu">
				<el-button @click="closeWindow" type="primary">{{$t('mygoods').details.ok}}</el-button>
			</div>
			
		</el-dialog>
				<div class="header-top">
			<div class="query-list">
				<!-- 菜单栏左 -->
				<div class="query-list-tcp">
					<div style="display:flex" >
					  <span class="demonstration"></span>
					  <!-- <el-cascader
					    expand-trigger="hover"
						ref="refHandle"
						change-on-select='true'
					    :options="options5"
					    v-model="selectedOptions2"
					    @change="handleChange"> 
					  </el-cascader> -->
						{{$t('other.a386')}}
					  	<el-select style="width: 250px;margin-right: 10px;"  @change="handleChange" v-model="selectedOptions2" :placeholder="$t('other.a50')">
						    <el-option
						      v-for="item in shopOptions"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
					</div>

				
					
					<div >
						<el-select style="width: 120px;margin:0 10px;"  @change="getShopItems01" v-model="productStatua" :placeholder="$t('other.a50')">
						    <el-option
						      v-for="item in productOptions"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
					</div>
					<div style="display:flex">
						<el-input clearable  :placeholder="$t('mygoods').search_tip" v-model="itemNameQuery"></el-input>
						 <el-button type="primary"   @click="goTosearch()">{{$t('mygoods').search}}</el-button>
					</div>
					<div style="margin-left: 20px;">
						<el-dropdown>
						  <el-button type="primary">
						    {{$t('other.a1946')}}<i class="el-icon-arrow-down el-icon--right"></i>
						  </el-button>
						  <el-dropdown-menu slot="dropdown">
						   <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="openDialog(0)"><span>{{$t('other.a1947')}}</span></el-dropdown-item>
						   <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="openDialog(1)"><span>{{$t('other.a1948')}}</span></el-dropdown-item>
						   <!-- <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="openDialog(2)"><span>按当前选择类目导入在仓单品库</span></el-dropdown-item>
						   <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="openDialog(3)"><span>按当前选择类目导入组合套餐库</span></el-dropdown-item> -->
						   <el-dropdown-item style="font-size:18px;padding:10px 30px"  @click.native="openDialog(4)"><span>{{$t('other.a1949')}}</span></el-dropdown-item>
						   <el-dropdown-item style="font-size:18px;padding:10px 30px"  @click.native="openDialog(5)"><span>{{$t('other.a1950')}}</span></el-dropdown-item>
						   
						   
						   
						   
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
					
				</div>
				<!-- 菜单栏右 -->
				<div class="query-list-tcp">
					<div class="create" >
						<el-button type="primary" @click="tobuShopee"  >{{$t('mygoods').synchronize}}</el-button>
					</div>
					<div class="create" v-show="!isBindItemModel">
						<el-button type="primary" @click="tocaiguo"  >{{$t('mygoods').Generate_warehouse_items}}</el-button>
						<span class="cirlle">{{isChooseList.length}}</span>
					</div>
				</div>
				
			</div>
		</div>
		<div style="margin-top: 160px;">
				   <div class="mygoods-list">
					   <div style="text-align: center;margin-top: 150px;" v-if="!newmygoodslist.length " >--{{$t('userStoreItems').nodata}}--</div>
				   	<div v-for="(item,indexOne) in newmygoodslist" :key="indexOne">
				   		<div class="list-item">
				   			<el-row>
				   				<el-col :span="24">
				   					<div class="item-view">
										<div style="display: flex;">
											<div style="margin-right: 10px;"><el-checkbox  v-model="item.checked02" @change="getList(item)"></el-checkbox></div>
											<div class="goods-pic"><img v-image-preview :src="changeImgURL(item)"></div>
											<div class="goods-desc">
												<div class="goods-title">
													<div>{{item.name}}</div>
													<div style="margin-top:10px" v-if="!item.hasVariation">Variation_Sku：{{item.itemSku}}</div>
												</div>
												<div class="goods-title-desc">
													<span class="goods-item">{{$t('mygoods').shop}}：{{item.shopName}}</span>
													<span class="goods-item">{{$t('mygoods').itemID}}：{{item.itemId}}</span>
													<span class="goods-item">{{$t('mygoods').price}}：{{item.price}}({{item.currency}})</span>
													<span class="goods-item">{{$t('mygoods').stock}}：{{item.stock}}</span>
												</div>
												<div class="goods-title-desc">
													<span class="goods-item" v-if="item.cusCode !==0">{{$t('mygoods').cusCode}}：{{item.cusCode}}</span>
													<span class="goods-item">{{$t('mygoods').Whether_to_booking}}：{{conversionStatus(item.isPreOrder)}}</span>
													<span class="goods-item">{{$t('mygoods').sales}}：{{item.sales}}</span>
													<span class="goods-item">{{$t('mygoods').update}}：{{getTime(item.updateTime)}}</span>
													<span class="goods-item">{{$t('other.a360')}}：{{item.status == 'NORMAL' ? $t('other.a1951') :  (item.status == 'UNLIST' ? this.$t('other.a1083') : $t('other.a1911'))}}</span>
												</div>
											</div>
										</div>
				   						<div style="display: flex;flex-direction: column;width: 130px;align-items: center;justify-content: center;" v-show="!isBindItemModel&&item.cusCode==0">
				   							<!-- <el-button style="width:130px" type="primary" size="mini" @click="targetVariation(item,null,true,1)" v-if="!item.checked"  v-show="!item.hasVariation">{{$t('mygoods').Generate_warehouse_items}}</el-button> -->
				   							<el-button style="width:130px" type="danger" size="mini" @click="targetVariation(item,null,true,2)" v-if="item.checked"  v-show="!item.hasVariation">{{$t('mygoods').isTarget}}</el-button>
											<el-dropdown v-if="!item.checked"  v-show="!item.hasVariation" >
												<span class="el-dropdown-link">
												<el-button style="width:130px; margin: 5px 0 0 0;" type="primary" size="mini" >{{$t('other.a1930')}}</el-button>
												</span>
												<el-dropdown-menu slot="dropdown">
												<el-dropdown-item  @click.native="targetVariation(item,variation,true,2,indexOne,index)">{{$t('other.a1931')}}</el-dropdown-item>
												<el-dropdown-item  @click.native="targetVariation(item,variation,false,2,indexOne,index)">{{$t('other.a1932')}}</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown> 
											
				   						   
										</div>
										
				   						<div   v-show="item.cusCode>0&&!isBindItemModel">
											<div style="display: flex;flex-direction: column;">
												<el-button style="min-width:130px" v-if="!item.checked"  type="success" size="mini"   :disabled="item.hasVariation">{{$t('mygoods').generated}}</el-button>
										
											</div>
				   						</div>
				   						
				   					</div>
				   				</el-col>
				   			</el-row>
				   			<!-- 商品含有多个sku -->
							<el-row    v-show="item.hasVariation">
				   				<el-col :span="24">
				   					<div class="list-variation">
				   						<div v-for="(variation,index) in item.variations" :key="index" class="variation-list">
				   							<div class="goods-title-desc">
				   								<el-row>
				   									<el-col :span="6" class="goods-item">Variation_Name：{{variation.name}}</el-col>
				   									<el-col :span="6" class="goods-item">Variation_Sku：{{variation.variationSku}}</el-col>
				   									<el-col :span="6" class="goods-item">{{$t('mygoods').price}}：{{variation.price}}({{item.currency}})</el-col>
				   									<el-col :span="3" class="goods-item">{{$t('mygoods').stock}}：{{variation.stock}}</el-col>
				   									<el-col :span="6"  class="goods-item">{{$t('mygoods').cusCode}}：{{variation.cusCode}}</el-col>
				   									<el-col :span="6" class="goods-btn">
														 <el-button style="min-width:130px"  type="success" size="mini" v-show="variation.cusCode>0&&!isBindItemModel">{{$t('mygoods').generated}}</el-button>
														<div style="display: flex;flex-direction: column;align-items: flex-end;justify-content: center;">
															<!-- <el-button style="min-width:130px"  :type="variation.isSingle==1 ? 'danger' :'primary'" size="mini" @click="targetVariation(item,variation,true,1,indexOne,index)"   v-show="!isBindItemModel&&variation.cusCode==0">导入实体单品库</el-button>
															<el-button style="min-width:130px;margin-top:5px"  :type="variation.isSingle==2 ? 'danger' :'primary'" size="mini" @click="targetVariation(item,variation,false,2,indexOne,index)"   v-show="!isBindItemModel&&variation.cusCode==0">导入虚拟套餐库</el-button> -->
															<el-button style="min-width:130px"  type="danger" size="mini" @click="targetVariation(item,variation)"   v-show="!isBindItemModel&&variation.cusCode==0&&variation.checked">{{$t('mygoods').isTarget}}</el-button>
															<el-dropdown  v-show="!isBindItemModel&&variation.cusCode==0&&!variation.checked">
																<span class="el-dropdown-link">
																<el-button style="width:130px; margin: 5px 0 0 0;" type="primary" size="mini"  v-show="!isBindItemModel&&variation.cusCode==0">{{$t('other.a1930')}}</el-button>
																</span>
																<el-dropdown-menu slot="dropdown">
																<el-dropdown-item  @click.native="targetVariation(item,variation,true,2,indexOne,index)">{{$t('other.a1931')}}</el-dropdown-item>
																<el-dropdown-item  @click.native="targetVariation(item,variation,false,2,indexOne,index)">{{$t('other.a1932')}}</el-dropdown-item>
																</el-dropdown-menu>
															</el-dropdown> 
														
														</div>
				   									</el-col>
				   								</el-row>
				   							</div>
				   						</div>
				   					</div>
				   				</el-col>
				   			</el-row>
				   		</div>
				   	</div>
				   	<!-- 分页器 -->
				   	<div v-if="newmygoodslist.length " class="Pager">
				   	    <el-pagination
				   	      @size-change="handleSizeChange"
				   		@current-change="handleCurrentChange"
				   		:current-page="currentPage1"
				   		:page-sizes="[15, 20, 30, 50]"
				   		:page-size="15"
				   		layout="total, sizes, prev, pager, next, jumper"
				   		:total="goodsTotal">
				   	    </el-pagination>
				   	  </div>
				   </div>
			  
	
		</div>
		
		</div>

	
		
		
	</div>
</template>

<script>
	import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
	import utils from  '../../utils/utils.js'
	import api from '../../api/api.js'
	import mygoods from '../../api/moudles/mygoods'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
				userShopslazada:JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
				shopList: [{
					label: this.$t('mygoods').allShop,
					value: '',
					children:null,
				},],
				storeList: [],
				status: {
					NORMAL: this.$t('other.a1082'),
					UNLIST: this.$t('other.a1083'),
					BANNED: this.$t('other.a1911'),
					DELETED: this.$t('other.a1912')
				},
				shipId: {
					value:{
						label:''
					}
				},
				chosedStore: '',
				itemNameQuery: '',
				statusValue: '',
				isChooseList: [],
				syncOrders:false,
				isParts:true,
				bindItemList: [],
				caigouTable: false,
				productOptions:[{
					 value: 'NORMAL',
					 label: this.$t('other.a1636')
				},{
					 value: 'UNLIST',
					 label: this.$t('other.a1083')
				},{
					 value: 'BANNER',
					 label: this.$t('other.a1637')
				},],
				productStatua:'NORMAL',
				bindTable: false,
				count: 0,
				catergoryType:0,
				active:-1,
				dialogVisible: false,
				showStore:false,
				remindDialog: false,
				itemCount: 0,
				flagNum:0,
				disabled:false,
				arr: [],
				chooseParams:null,
				isBindItemModel: false,
				sellerMessage: "",
				visiableMessage: '',
				stockRemindList: [],
				remindCount: 0,
				selectShop: '',
				offset:15,
				currentPage:0,
				type:0,
				currentPage1:0,
				goodsName:null,
				cost_prict:'',
				sku_name:'',
				storetable:false,
				input10:'',
				bindSuccess:[],
				listCopy:[],
				bindError:[],
				bindreport:false,
				addItmes:this.$t('other.a1913'),
				activeTheOne:true,
				activeName: 'first',
				isShopee:true,
				showSales:false,
				salesItem:null,
				choseCategroyId:0,
				shopOptions:[],
				whichMethods:null,
				options:[{
					label:this.$t('other.a1933'),
					value:true,
				},{
					label:this.$t('other.a1934'),
					value:false,
				}],
				selectedOptions2:[],
				text:'',
				options5:[],
				value10:[],
				getDataList:{
					categoryIds:null,
					offset:null,
					page:null,
					userId:null,
					shopIds: null,
					status:null,
					itemName:null,
				}
				
			}
		},
		components: {
			QrcodeDialog 
		},
		
		computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
				userPos: state => state.shopaccess.userInfo.userPos,
				goodsTotal:state => state.mygoods.goodsTotal,
				successtotal:state => state.mygoods.successtotal,
				errorList:state => state.mygoods.errorList,
				succesList:state => state.mygoods.succesList,
				curCodeList:state => state.mygoods.curCodeList,
				lazadaitems:state => state.mygoods.lazadaitems,
				lazadaCount:state => state.mygoods.lazadaCount,
				cateGoryListCopy:state => state.mygoods.cateGoryListCopy,
				already:state => state.mygoods.already,
				
				
			}),
			
			targetList(){
				let arr=this.mygoodslist.filter(p => {
					if(p.checked02){
						return p
					}
				})
				return arr
				
			},
			remindList() {
				return this.stockRemindList;
			},
			newmygoodslist(){
	
				let arr=this.mygoodslist
				
				return arr
			},
		
				
		},
		watch:{
			already(){
				if(this.already){
					this.shopList=[{
					label: this.$t('mygoods').allShop,
					value: '',
					children:null,
				},]
					 this.ttp()
				
				}
			},
			itemNameQuery(){
				if(this.itemNameQuery === ""){
					this.getDataList.itemName=""
					this.getShopAllItems(this.getDataList)
				}
				
			},
			successtotal(){
				this.showMessage(this.$t('other.a964')+this.successtotal+this.$t('other.a1914')+this.shipId.shopId.shopName + this.$t('other.a1861'))
			},
			selectedOptions2() {
			      if (this.$refs.refHandle) {
			        this.$refs.refHandle.dropDownVisible = false; //监听值发生变化就关闭它
			      }
			    }
		},
		created(){
			
			this.init()
			
			// this.handleClick()
			
		},
		methods: {
			...mapActions('mygoods', [
			'getShopAllItems',
			'addGoodsInStore',
			'getBindInfo',
			'tongBuShopee',
			'getLazadaWarehouseitems',
			'tongBuLazada',
			'getGoodsOrder',
			'getItemSales',
			'getInventoryTurnover',
			'getCategoryByshop',
			'batchCreateStoreItem',
			'addNotProductInStore'
			]),
			
			...mapMutations('mygoods', [
			'GET_CURCODE_LIST_NULL',
			'SET_SUCCESS_ERROR_NULL',
			'KEEP_CHOOSED_ITEM',
			'SET_ITEM_TRUE'
				
			]),
			
			comfirm(){
				console.log(this.value10)
				let arr=this.value10.map(p => {
					return {
						shopId:p,
						userId:this.userId
					}
				})
				arr.forEach(p => {
					this.tongBuShopee(p)
				})
				
				this.$message.success(this.$t('other.a1935'))
				this.syncOrders=false
			
			},
			
			showShopName(id){
				let ccp=null
				if(this.userPos === 'SELLER'){
					ccp=utils.showshopNameByshopId()
					return ccp[id]
				}else if(this.userPos === 'STORE'){
					ccp=utils.showstoreNameBystoreId()
					return ccp[id]
				}
			},
			
			openDialog(num){
				this.storeList=utils.getAllstoreExpect(4)
				this.whichMethods=num
				if(num == 0){
					this.text=this.$t('other.a1952')
					
				}else if(num == 1) {
					this.text=this.$t('other.a1953')
					
					
				}else if(num == 2){

					this.text=this.$t('other.a1954')
					
					
				}else if(num === 3){
					this.text=this.$t('other.a1955')
				}else if(num === 4){
					this.text=this.$t('other.a1956')
					if(this.targetList.length == 0){
						this.$message.error(this.$t('other.a1939'))
						return
					}
					
				}else if(num === 5){
					this.text=this.$t('other.a1957')
					if(this.targetList.length == 0){
						this.$message.error(this.$t('other.a1939'))
						return
					}
				}
				this.showStore=true
			},
			
			massGenerage(){
				let params={
					categoryIds:[],
					itemIds:[],
					shopIds:[],
					storeId:this.chosedStore.value,
					type:this.whichMethods,
					userId:this.userId,
					userName:this.userName,
					type:this.whichMethods,
					storeName:this.chosedStore.label
				}
				if(this.whichMethods===0 || this.whichMethods === 1){
					params.shopIds=[this.selectedOptions2]
					
				}else if(this.whichMethods === 2 || this.whichMethods === 3){
					params.categoryIds=this.chooseParams.slice(1)
					params.shopIds=[this.selectedOptions2]
				}else if(this.whichMethods === 4 || this.whichMethods === 5){
					params.itemIds=this.targetList.map(p => {return p.itemId})
					params.shopIds=null
				}
				console.log(params)
				this.batchCreateStoreItem(params)
				this.chosedStore=''
				this.showStore=false
				
				
			},
			
			handleChange(value) {
				console.log(value)
				console.log(this.selectedOptions2)
				console.log(this.cateGoryListCopy)
				if(value.length === 1){
					this.catergoryType=0
				}else{
					this.catergoryType=1
				}
				this.choseCategroyId=value[value.length-1];
				let categoryIds=[];
				this.cateGoryListCopy.forEach((p)=>{
				this.pushIds(p,categoryIds,false);
				})
				let arr=new Set([...categoryIds])
				let arr2=Array.from(arr)
				
				console.log(arr2)
				arr2.unshift(value[0])
				this.chooseParams= arr2
				console.log(this.chooseParams)
				this.getDataList.categoryIds=null,
				this.getDataList.shopIds=[this.selectedOptions2],
				
				this.getShopAllItems(this.getDataList)
				
			  
			},
			getCategory(value) {
				let category={};
				this.cateGoryListCopy.forEach((p)=>{
					if(p.value==value){
						category= p;
					}
					if(p.hasChildren){
						p.children.forEach((q)=>{
							if(q.value==value){
								category= q;
							}
							if(q.hasChildren){
								q.children.forEach((r)=>{
									if(r.value==value){
										category= r;
									}
								})
							}
						})
					}
				})
				return category;
				},
				
				pushIds(category,ids,isVal){
					if(isVal){
						if(category.hasChildren){
							category.children.forEach((p)=>{
							this.pushIds(p,ids,true);
							})
						}else{
							ids.push(category.value)
						}
					}else{
						if(category.value==this.choseCategroyId){
							this.pushIds(category,ids,true);
						}else{
							if(category.hasChildren){
								category.children.forEach((p)=>{
								this.pushIds(p,ids,false);
								})
							}
						}
					}
				},
			getCategoryByshipId(){
				let allShopId=this.shopList.map(p => {return p.value}).slice(1)
				console.log(allShopId)
				// allShopId.forEach(p => {
				// 	this.getCategoryByshop({shopId:p})
				// })
				this.chooseParams=[this.shopList[1].value]

				let arr=this.shopList.slice(1).map(k => {
					return {
						shopId:k.value
					}
				})

				// api
				// .getCategoryByshops(arr)
				// .then(res => {
				// 	if(res.code === 200) {
				// 		console.log('店铺下的类目',res.data)
				// 	}
				// })
				
				
				
			},
			
			getList(item){
				console.log(item)
				console.log(this.targetList)
				// this.SET_ITEM_TRUE(item)
				
			},
			//查看商品的订单
			viewGoodsOrder(item,variation){
				console.log(item)
				console.log(variation)
				let params=null
				if(!item.hasVariation) {
					params={
						itemId:item.itemId,
						skuId:0
					}
				}else{
					params={
						itemId:variation.itemId,
						skuId:variation.variationId
					}
				}
				console.log(params)
				this.$router.push({path:'/orders/shopee',query:{...params}})
			},
			//查看商品的销售情况 
			viewSales(item,variation) {
				let params={}
				if(item.hasVariation) {
					params={
						end:utils.getRecentSevenDay(0),
						start:utils.getRecentSevenDay(-7),
						itemId:item.itemId,
						shopId:item.shopid,
						variationId:variation.variationId
					}
				}else{
					params={
						end:utils.getRecentSevenDay(0),
						start:utils.getRecentSevenDay(-7),
						itemId:item.itemId,
						shopId:item.shopid,
						variationId:0
					}
				}
				console.log(params)
				this.getItemSales(params)
				this.getInventoryTurnover(params)
				this.salesItem=params
				this.showSales=true
			},
			
			
			handleClick(tap) {
			
			   if(tap.label === "shopee") {
				   this.selectShop=''
				   this.isShopee=true
				   this.shopList=[{
				       	value: '',
				    	label: this.$t('other.a1915')
				       },
				   	]
					this.shipId= {
						value:{
							label:''
						}
					},
				   this.userShops.forEach(item => {
				   	let oop={
				   		label:item.shopName,
				   		value:item.shopId
				   	}
				   	this.shopList.push(oop)
				   })
				   this.getShopItems()
			   }else if(tap.label === "Lazada") {
				    this.selectShop=''
				   this.isShopee=false
				  this.shopList=[{
				  	value: '',
				   	label: this.$t('other.a1915')
				      },
				  	]
					this.shipId= {
						value:{
							label:''
						}
					}
				   let arr=this.lazadashopId.map(p => {
					  return {
						   label:p.name,
						   value:p.sellerId
					   }
				   })
				   arr.forEach(p => {
					   this.shopList.push(p)
				   })
				
			   }
			   this.getShopItems()
			  },
			init(){
				
					this.userShops.forEach(item => {
					let oop={
						label:item.shopName,
						value:item.shopId
					}
					this.shopList.push(oop)
					})
					
					this.selectShop=this.shopList[1].value
					this.selectedOptions2[0]=this.shopList[1].value

					this.shopOptions=JSON.parse(localStorage.getItem('userInfo')).shopeeShops.map(p => {
						return {
							label:p.shopName,
							value:p.shopId,
						}
					})

					this.selectedOptions2=this.shopOptions[0].value
					this.SET_SUCCESS_ERROR_NULL()
					this.getCategoryByshipId()
					this.getShopItems01()
					
				
			
				
				
				
			},
			
			// getremind() {
			// 	this.stockRemindList = [];
			// 	this.remindCount = 0;
			// 	this.userShops.forEach((shop) => {
			// 		api.getShopStockRemind({
			// 			shop_id: shop.shopId
			// 		}).then(res => {
			// 			if (res.code === 200) {
						
			// 				res.data.forEach((stocks) => {
			// 					this.stockRemindList.push(stocks);
			// 					this.remindCount++;
			// 				})

			// 			}
			// 		})
			// 	});
			// },
			changeImgURL(item) {
				return item.image
			},
		
			addBindToList(item, variation) {
				if (variation == null) {
					variation = {
						variationId: 0
					}
				}
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "shopId", this.shipId);
				this.$set(param, "variation", variation);
				let isInList = false;
				for (let i = 0; i < this.bindItemList.length; i++) {
					if (this.bindItemList[i].itemId == param.itemId) {
						if (!this.bindItemList[i].hasVariation && !param.hasVariation) isInList = true;
						if (this.bindItemList[i].hasVariation && param.hasVariation &&
							this.bindItemList[i].variation.variationId == param.variation.variationId) isInList = true;
					}

				}
				if (!isInList) this.bindItemList.push(param);
				this.itemCount = this.bindItemList.length
				console.log('需要绑定的商品',this.bindItemList)
			},
		
			deleteChoose(item) {
				if(item.shopee) {
					this.$confirm(this.$t('other.a1940'), this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
					  var index = this.isChooseList.findIndex(choose => {
					  	if (choose.itemId == item.itemId && choose.variation.variationId == item.variation.variationId) {
					  		return true
					  	}
					  })
					  
					  this.mygoodslist.forEach(p => {
					  	if(item.itemId==p.itemId){
					  		if(item.hasVariation&&p.hasVariation){
					  			p.variations.forEach(q=>{
					  				if(q.variationId==item.variation.variationId){
					  					q.checked=false;
					  				}
					  			})
					  		}else if(!item.hasVariation&&!p.hasVariation){
					  			p.checked =false
					  		}
					  	}
					  })
					  
					  this.isChooseList.splice(index, 1);
					  this.count = this.isChooseList.length;
					}).catch(() => {
						
					 
					});
					
					
					
				}else {
					let index = this.isChooseList.findIndex(choose => {
						if (choose.itemId == item.itemId && choose.variation.variationId == item.variation.variationId) {
							return true
						}
					})
					
					this.lazadaitems.forEach(p => {
						if(item.itemId==p.itemId){
							if(item.hasVariation&&p.hasVariation){
								p.variations.forEach(q=>{
									if(q.variationId==item.variation.variationId){
										q.checked=false;
									}
								})
							}else if(!item.hasVariation&&!p.hasVariation){
								p.checked =false
							}
						}
					})
					console.log(index)
					console.log(this.mygoodslist)
					this.isChooseList.splice(index, 1);
					this.count = this.isChooseList.length;
				}
				
			},
			getShopItems() {
				
			if(this.isShopee) {
				this.selectShop = this.shipId.value.value
				const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					type:this.type,
					shopId: this.selectShop
				}
				console.log(params)
				this.getShopAllItems(params)
			}else{
				this.selectShop = this.shipId.value.value
				const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					type:this.type,
					shopId: this.selectShop
				}
				
				console.log('lazada',params)
				this.getLazadaWarehouseitems(params)
			}
				
			},
			//获取导入商品页面的数据
			getShopItems01() {
				this.getDataList.categoryIds=this.chooseParams.length == 1  ? null : this.chooseParams
				this.getDataList.offset=this.offset
				this.getDataList.page=this.currentPage
				this.getDataList.userId=this.userId
				this.getDataList.shopIds= [this.chooseParams[0]]
				this.getDataList.status=this.productStatua
				this.getDataList.itemName=''

				if(this.$route.query.id){
					this.productStatua=this.$route.query.status
					let id=this.$route.query.id
					this.getDataList.itemName=id
					this.getDataList.status=this.productStatua
					this.getShopAllItems(this.getDataList)
				}else{
					this.getShopAllItems(this.getDataList)
				}

				
			},
		
			//创建采购单
			createOrder() {
				let variantList = [];
				let chooseList = this.isChooseList;
				console.log(chooseList)
				
				if (chooseList.length == 0) {
					this.showMessage(this.$t('other.a1919'));
					return;
				}
				if (this.chosedStore == '') {
					this.showMessage(this.$t('other.a1920'));
					return;
				}
				for (let i = 0; i < chooseList.length; i++) {
					let variation = {
						address:'',
						cost:chooseList[i].cost,
			      		itemId:chooseList[i].itemId,
						component:chooseList[i].component,
						itemName:chooseList[i].name,
						shopName:chooseList[i].shopName,
						shopId:chooseList[i].shopid,
						image:chooseList[i].hasVariation ? chooseList[i].variation.attributeUrl ? chooseList[i].variation.attributeUrl : chooseList[i].image : chooseList[i].image,
						skuName:chooseList[i].variation.variationSku,
						variationName:chooseList[i].variation.name,
						storeId:this.chosedStore.value,
						storeName:this.chosedStore.storeName,
						userId:this.userId,
						userName:this.userName,
						variationId:chooseList[i].variation.variationId,
						shopee:chooseList[i].shopee,
						packageHeight:chooseList[i].packageHeight,
						packageLength:chooseList[i].packageLength,
						packageWidth:chooseList[i].packageWidth,
						weight:chooseList[i].weight,
						rate:Number(chooseList[i].rate),
						groupId:this.$route.query.groupId ? this.$route.query.groupId : null
					}
					
					variantList.push(variation);
				}

				console.log(variantList)
				if(!this.isParts){
				    this.addNotProductInStore(variantList)
					this.storetable=true
					console.log('添加至组件库',variantList)
				
				}else{
					this.addGoodsInStore(variantList)
					this.storetable=true
					console.log('添加至单品库',variantList)
				}
				
			
		
			},
			vertifyStoreType(){
				console.log(this.chosedStore.value)
				
				if(!this.flagNum){
					this.listCopy=JSON.parse(JSON.stringify(this.isChooseList))
					this.flagNum++
				}
				let flag=JSON.parse(localStorage.getItem('userInfo')).stores.find(p => p.storeId === this.chosedStore.value)
				// if(flag.sellerId == JSON.parse(localStorage.getItem('userInfo')).userId){
				// 	this.options.push({
				// 		label:'分销选品库',
				// 		value:0
				// 	})
				// 	console.log(this.isChooseList)
				// 	this.isChooseList.forEach(p => {
				// 		p.component=0
				// 	})
				// 	this.disabled=true
				// }else{
				// 	this.options.splice(2,1)
				// 	this.isChooseList=this.listCopy
				// 	this.disabled=false
				// }

				this.options.splice(2,1)
					this.isChooseList=this.listCopy
					this.disabled=false
				console.log(flag)
				
			},

			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},
			getTime(time) {
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp
			},
			//状态转换
			conversionStatus(ttp) {
				if(ttp){
					return this.$t('mygoods.yes')
				}else{
					return this.$t('mygoods.no')
				}
			},
		
			tobuShopee(){
				this.options5=utils.getAllshop().slice(1)
				this.syncOrders=true
			},
			tocaiguo() {
				this.storeList = utils.getAllstoreExpect(4)
				console.log(this.storeList)
				

				this.caigouTable = true;
			},
		
		
			targetVariation(item, variation,componets,num,indexOne,index) {

				let param = JSON.parse(JSON.stringify(item));
				variation==null?null:variation.checked=!variation.checked
				item.checked = !item.checked
				// console.log('param',param,variation)

				param.num=0
				param.skuName=''
				param.cost=0
				param.component=componets
				param.shopName=this.shipId.value.label
				param.anotherName=''
				param.variation=variation == null ? {
					variationId: 0,
					name: '',
					stock: 0
				} : variation
				let isInList = false;
				for (let i = 0; i < this.isChooseList.length; i++) {
					if ((param.hasVariation && this.isChooseList[i].hasVariation &&
							this.isChooseList[i].variation.variationId == param.variation.variationId) ||
						(!param.hasVariation && !this.isChooseList[i].hasVariation && this.isChooseList[i].itemId == param.itemId))
						{
							isInList = true;
							this.isChooseList.splice(i,1)
							
						}
				}
				if (!isInList) this.isChooseList.push(param);
				
				console.log('param',param)
				
			},
			cleanForm() {
				this.isChooseList = [];
				this.KEEP_CHOOSED_ITEM(this.isChooseList)
				this.sellerMessage = '';
				this.count=this.isChooseList.length
				
				if(this.isShopee){
					this.getShopItems01()
				}else{
					this.getShopItems()
				}
			},
			
			
			//控制每页显示订单条数
			handleSizeChange(val) {
							 console.log(`每页 ${val} 条`);
							 this.offset=parseInt(`${val}`)
							 this.getDataList.offset=parseInt(`${val}`)
							 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
						this.currentPage=(parseInt(`${val}`) -1) * this.offset
						this.getDataList.page=this.currentPage
						// const params={
						// 	categoryIds:this.chooseParams.length == 1  ? null : this.chooseParams,
						// 	offset:this.offset,
						// 	page:this.currentPage,
						// 	userId:this.userId,
						// 	type:this.type,
						// 	shopId: this.chooseParams[0],
						// 	logisticsName:this.productStatua
						// }
						//  console.log(params)
						 this.getShopAllItems(this.getDataList)
						 this.currentPage=0
			  },
			  //搜索商品名称查找
			  goTosearch(){
				  this.goodsName=this.itemNameQuery
				  this.getDataList.itemName=this.goodsName
				//   const params={
				// 	  offset:this.offset,
				// 	  page:this.currentPage,
				// 	  userId:this.userId,
				// 	  type:this.type,
				// 	  shopId:this.selectShop,
				// 	  itemName:this.goodsName
				//   }
				//   console.log(params)
				   this.getShopAllItems(this.getDataList)
			  },
		
			
			   closeWindow(){
				   this.storetable=false
				   this.caigouTable=false
				   this.count=0
				   this.bindreport=false
				   this.bindTable=false
				   this.isChooseList=[]
				   this.SET_SUCCESS_ERROR_NULL()
				   this.getShopItems01()
				   if(this.$route.query.component=='products'){
					   this.$router.push({path:'/userStoreItems/products'})
					  
					}else if(this.$route.query.component=='accessories'){
					  this.$router.push({path:'/userStoreItems/accessories'})
					}
				 
			   },
			  ttp01(num){
			  	
			  	if(this.active == num) {
			  		this.active=-1
			  	}else{
			  		this.active=num
			  	}
			  },


		}
	}
</script>

<style>

	.mygoods .demo-table-expand {
		font-size: 0;
	}

	.mygoods .demo-table-expand label {
		width: 120px;
		color: #99a9bf;
	}

	.mygoods .demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	/* .mygoods {
		flex: 1;
		padding: 60px 0 0 221px;
		
	} */

	.mygoods .el-dialog__body {
		padding-top: 0px;
	}

	.mygoods .list-item {
		justify-content: space-around;
		align-items: center;
		margin: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

/* 	.list-variation {
		justify-content: space-around;
		align-items: center;
	} */

	.mygoods .item-view {
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 10px 20px;
		border-radius: 10px;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
	}
	.mygoods .goods-title-desc .el-row {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    box-sizing: border-box;
	    padding: 0 20px;
	}


	.mygoods .variation-list {
		padding: 5px 0;
		border-bottom: 1px solid #eee;
	}

	.mygoods .el-collapse-item__content {
		padding: 0rem;
	}

	.mygoods  .goods-pic {
		width: 80px;
		height: 80px;
		margin-right: 25px;
	}

	.mygoods .el-dialog__body {
		padding-bottom: 0px !important;
	}

	img {
		width: 100%;
	}

	.mygoods .el-collapse-item__header {

		float: right;
	}

	.mygoods .goods-desc {
		display: flex;
		margin-left: 10px;
	
	}

	.mygoods .goods-item {
		display: inline-block;
		margin: 2px 10px;
		color: #00193A;
		
	}
	.mygoods .goods-btn {
		display: inline-block;
		text-align: right;
	}
	.mygoods .goods-title-desc{
		display: flex;
		flex-direction: column;
	}
	

	.mygoods .goods-title {
		width: 300px;
		
		    box-sizing: border-box;
		    padding: 5px;
	}

	.mygoods .mygoods-title,
	.query-list {
		display: flex;
		justify-content: space-between;
		margin: 15px 0 0 0;
		padding: 10px 0;
		/* border-bottom: 1px #E0E0E0 solid; */
		
	}

	.mygoods .shop-choose {
		display: inline-block;
		margin-right: 15px;
	}

	.mygoods .create {
		position: relative;
		margin-left: 30px;
	}



	.mygoods .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
		color: #fff;
	}
	.mygoods .mygoods-search {
		display: flex;
	}
	.mygoods .quit-box{
		display: flex;
		justify-content: center;
		width: 90%;
	}
	.mygoods .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	.mygoods .choos-store{
		display: flex;
		justify-content: space-between;
	
		padding: 15px 10px;
	}
	.mygoods .quit-wapper{
		display: flex;
		justify-content: space-between;
		width: 55%;
	}
	.mygoods .quit-wrapper-item{
		font-size: 18px;
	}
	.mygoods .ttp-uu{
		text-align: right;
		box-sizing: border-box;
		padding: 10px;
		width: 100%;
	}
	.serchCuscode{
		display: flex;
		margin-left: 15px;
		
	}
	
	/** 去除input输入框样式 */
	input[type=number]::-webkit-inner-spin-button {
	  -webkit-appearance: none;
	}
	.mygoods .number__input {
	  border: 1px solid #ccc;
	}
	.mygoods .el-dialog--center .el-dialog__body{
		padding: 0px !important;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
	}

	.mygoods .el-message--success{
		z-index: 9999999!important;
	}
/* 	.mygoods .el-table__header-wrapper{
		display: flex;
		justify-content: center;
	} */
	.mygoods .el-table__empty-text{
		text-align: center;
	}
/* 	.mygoods .el-table__body-wrapper{
		display: flex;
		justify-content: center;
	} */
	.mygoods .header-top{
	position: fixed;
		position: fixed;
		z-index: 7;
	    top:138px;
		background-color: #fff;
		left: 225px;
		right: 0;

		box-sizing: border-box;
		padding: 0 5px;
		border-bottom: 1px solid #eee;
		
	}
	.mygoods .mygoods-list{
	
		margin-bottom: 50px;
	
	}
	.mygoods  .query-list-tcp{
		display: flex;
		align-items: center;
	}
	.mygoods  .el-tabs__header{
		position: fixed;
		margin: 10px 0  0 30px;
		z-index: 7;
	}
/* 	lazada板面 */
     .mygoods-list-lazada{
		 margin-top: 120px;
	 }
	 
	 .mygoods .item-view-lazada{
		 display: flex;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	 }
	 
	 .mygoods .unfold:nth-of-type(n+1){
	 	display: none;
	 	
	 }
	 
	 .mygoods .list-item{
		 border-radius: 10px;
	 }

</style>
